import {Marker} from "@/models/Marker";

export class TargetMarker extends Marker{

  constructor(data, map) {
    super(data,map);
    this.marker.setZIndex(99999999);
  }

  getIconSize () {
    return 20;
  }

  getIconName (){
    return 'target';
  }

  getIconOpacity (){
    return 1;
  }
}
